import * as React from "react";

import { cn } from "@/lib/utils";
import { FORM_CONTROLS } from "@/design-system";

export interface InputProps extends React.ComponentProps<"input"> {
  /** Show error validation styling */
  error?: boolean;
  /** Show success validation styling */
  success?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, success, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex min-h-[44px] w-full rounded-md border border-input bg-background px-3 py-2 text-base input-interactive file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          error && FORM_CONTROLS.validation.error,
          success && !error && FORM_CONTROLS.validation.success,
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
